import _classCallCheck from "/Users/marksteve/Projects/thinkingmachines/xkcd-dot/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/marksteve/Projects/thinkingmachines/xkcd-dot/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/marksteve/Projects/thinkingmachines/xkcd-dot/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/marksteve/Projects/thinkingmachines/xkcd-dot/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/marksteve/Projects/thinkingmachines/xkcd-dot/node_modules/@babel/runtime/helpers/esm/inherits";
import { RoughGeneratorBase } from './generator-base';
export var RoughGenerator =
/*#__PURE__*/
function (_RoughGeneratorBase) {
  _inherits(RoughGenerator, _RoughGeneratorBase);

  function RoughGenerator(config, surface) {
    _classCallCheck(this, RoughGenerator);

    return _possibleConstructorReturn(this, _getPrototypeOf(RoughGenerator).call(this, config, surface));
  }

  _createClass(RoughGenerator, [{
    key: "line",
    value: function line(x1, y1, x2, y2, options) {
      var o = this._options(options);

      return this._drawable('line', [this.lib.line(x1, y1, x2, y2, o)], o);
    }
  }, {
    key: "rectangle",
    value: function rectangle(x, y, width, height, options) {
      var o = this._options(options);

      var paths = [];

      if (o.fill) {
        var points = [[x, y], [x + width, y], [x + width, y + height], [x, y + height]];

        if (o.fillStyle === 'solid') {
          paths.push(this.lib.solidFillPolygon(points, o));
        } else {
          paths.push(this.lib.patternFillPolygon(points, o));
        }
      }

      paths.push(this.lib.rectangle(x, y, width, height, o));
      return this._drawable('rectangle', paths, o);
    }
  }, {
    key: "ellipse",
    value: function ellipse(x, y, width, height, options) {
      var o = this._options(options);

      var paths = [];

      if (o.fill) {
        if (o.fillStyle === 'solid') {
          var shape = this.lib.ellipse(x, y, width, height, o);
          shape.type = 'fillPath';
          paths.push(shape);
        } else {
          paths.push(this.lib.patternFillEllipse(x, y, width, height, o));
        }
      }

      paths.push(this.lib.ellipse(x, y, width, height, o));
      return this._drawable('ellipse', paths, o);
    }
  }, {
    key: "circle",
    value: function circle(x, y, diameter, options) {
      var ret = this.ellipse(x, y, diameter, diameter, options);
      ret.shape = 'circle';
      return ret;
    }
  }, {
    key: "linearPath",
    value: function linearPath(points, options) {
      var o = this._options(options);

      return this._drawable('linearPath', [this.lib.linearPath(points, false, o)], o);
    }
  }, {
    key: "arc",
    value: function arc(x, y, width, height, start, stop) {
      var closed = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : false;
      var options = arguments.length > 7 ? arguments[7] : undefined;

      var o = this._options(options);

      var paths = [];

      if (closed && o.fill) {
        if (o.fillStyle === 'solid') {
          var shape = this.lib.arc(x, y, width, height, start, stop, true, false, o);
          shape.type = 'fillPath';
          paths.push(shape);
        } else {
          paths.push(this.lib.patternFillArc(x, y, width, height, start, stop, o));
        }
      }

      paths.push(this.lib.arc(x, y, width, height, start, stop, closed, true, o));
      return this._drawable('arc', paths, o);
    }
  }, {
    key: "curve",
    value: function curve(points, options) {
      var o = this._options(options);

      return this._drawable('curve', [this.lib.curve(points, o)], o);
    }
  }, {
    key: "polygon",
    value: function polygon(points, options) {
      var o = this._options(options);

      var paths = [];

      if (o.fill) {
        if (o.fillStyle === 'solid') {
          paths.push(this.lib.solidFillPolygon(points, o));
        } else {
          var size = this.computePolygonSize(points);
          var fillPoints = [[0, 0], [size[0], 0], [size[0], size[1]], [0, size[1]]];
          var shape = this.lib.patternFillPolygon(fillPoints, o);
          shape.type = 'path2Dpattern';
          shape.size = size;
          shape.path = this.polygonPath(points);
          paths.push(shape);
        }
      }

      paths.push(this.lib.linearPath(points, true, o));
      return this._drawable('polygon', paths, o);
    }
  }, {
    key: "path",
    value: function path(d, options) {
      var o = this._options(options);

      var paths = [];

      if (!d) {
        return this._drawable('path', paths, o);
      }

      if (o.fill) {
        if (o.fillStyle === 'solid') {
          var shape = {
            type: 'path2Dfill',
            path: d,
            ops: []
          };
          paths.push(shape);
        } else {
          var size = this.computePathSize(d);
          var points = [[0, 0], [size[0], 0], [size[0], size[1]], [0, size[1]]];

          var _shape = this.lib.patternFillPolygon(points, o);

          _shape.type = 'path2Dpattern';
          _shape.size = size;
          _shape.path = d;
          paths.push(_shape);
        }
      }

      paths.push(this.lib.svgPath(d, o));
      return this._drawable('path', paths, o);
    }
  }]);

  return RoughGenerator;
}(RoughGeneratorBase);